function getNidInquiryStatusTextUsetInfo(type) {
    switch (type) {
      case "All":
        return {txt:"احراز هویت نشده",label:"not identity-verified"};
      case "Accepted":
        return {txt:"احراز هویت شده",label:"identity-verified"};
      case "ReadyForInquiry":
        return {txt:"در انتظار احراز هویت",label:"not identity-verified"}
      case "InProgress":
        return {txt:"در انتظار احراز هویت",label:"not identity-verified"};
      case "Rejected":
        return {txt:"احراز هویت رد شده",label:"revoked identity-verified"};
      default:
        return "";
          }
   
  }
  export default getNidInquiryStatusTextUsetInfo;
